import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AddActiveClass = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    const link = document.querySelector('[data-id="protocol-header-Setup"]');
    if (link && link.classList) {
      link.classList.add('active');
    }
  }, [location?.pathname]);

  return null;
};

export default AddActiveClass;
